document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-nav-toggle]');
  const nav = document.querySelector('[data-nav]');

  const closeSubmenus = (except = null) => {
    document.querySelectorAll('[data-submenu-toggle]').forEach((button) => {
      if (button === except) return;
      button.setAttribute('aria-expanded', 'false');
      const submenu = document.getElementById(button.getAttribute('aria-controls'));
      if (submenu) submenu.classList.remove('is-open');
    });
  };

  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('is-open', !open);
      if (open) closeSubmenus();
    });
  }

  document.querySelectorAll('[data-submenu-toggle]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.stopPropagation();
      const open = button.getAttribute('aria-expanded') === 'true';
      closeSubmenus(button);
      button.setAttribute('aria-expanded', String(!open));
      const submenu = document.getElementById(button.getAttribute('aria-controls'));
      if (submenu) submenu.classList.toggle('is-open', !open);
    });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.site-nav__item--has-children')) closeSubmenus();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeSubmenus();
      if (toggle && nav) {
        toggle.setAttribute('aria-expanded', 'false');
        nav.classList.remove('is-open');
      }
    }
  });

  const els = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window)) {
    els.forEach((el) => el.classList.add('is-visible'));
    return;
  }
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  els.forEach((el) => io.observe(el));
});
